var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['card-text',_vm.disabled?'disabled':'enable'],on:{"click":function($event){return _vm.$emit('click')}}},[_c('b',[_vm._v(_vm._s(_vm.tip))]),_c('br'),_c('br'),_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }